module.exports = __webpack_public_path__ + "img/planner-explicae.96e64ba9.png";